import axiosInstance from './axios.service';

/**
 * @typedef {'CREATE_SECTION'|'UPDATE_SECTION'|'DELETE_SECTION'|'SHIFT_SECTIONS'|
 *           'CREATE_CATEGORY'|'UPDATE_CATEGORY'|'DELETE_CATEGORY'|'SHIFT_CATEGORIES'} OpType
 *
 * @typedef {Object} CatalogOp
 * @property {string}  id        - unique op id (op_1, op_2, …)
 * @property {OpType}  type
 * @property {string}  entityId  - real server ID or 'temp_xxx' for unsaved entities
 * @property {string}  [scope]   - used by SHIFT ops to identify parent (section id or 'root')
 * @property {Object}  payload   - type-specific fields sent to the API
 */

/**
 * @typedef {Object} SectionDto
 * @property {string}  id
 * @property {string}  name
 * @property {boolean} adultsOnly
 */

/**
 * POST /operator/v1/sections/create
 * @param {{ name: string, adultsOnly?: boolean }} payload
 * @returns {Promise<{data: SectionDto}>}
 */
export const createSection = (payload) => axiosInstance.post('/operator/v1/sections/create', payload);

/**
 * POST /operator/v1/sections/update
 * @param {{ id: string, name?: string, adultsOnly?: boolean }} payload
 * @returns {Promise<{data: SectionDto}>}
 */
export const updateSection = (payload) => axiosInstance.post('/operator/v1/sections/update', payload);

/**
 * POST /operator/v1/sections/delete
 * @param {{ id: string }} payload
 */
export const deleteSection = (payload) => axiosInstance.post('/operator/v1/sections/delete', payload);

/**
 * POST /operator/v1/sections/shift
 * @param {{ sections: string[] }} payload
 */
export const shiftSections = (payload) => axiosInstance.post('/operator/v1/sections/shift', payload);

/**
 * POST /operator/v1/sections/list
 * @param {{ pointId?: string }} [payload]
 * @returns {Promise<{data: SectionDto[]}>}
 */
export const listSections = (payload) => axiosInstance.post('/operator/v1/sections/list', payload || {});
